angular.module('dpw.services')

    .factory('myAccountUtils', ['$window', 'api', 'popupUtil', 'mixpanelService', function ($window, api, popupUtil, mixpanelService) {
        return {

            /**
             * Wrapper for `api.myAccount.developers.get()`.
             *
             * @param {Object} options
             * @param {Object} [options.data] - Data which will be sent to the back-end.
             * @param {Function} options.onSuccess
             */
            getDevelopers: function (options) {
                options = options || {};
                api.call(api.myAccount.developers.get(options.data), options.onSuccess, onError);

                function onError(data, defaultErrorHandler) {
                    var errorCode = _.get(data, 'errors[0].errorCode');

                    // DPW-3359
                    if (errorCode === 'OAU-213') {
                        popupUtil.ok({
                            content: RCDPW.Lang.MyAccount.TOKEN_NOT_FOUND,
                            btnName: 'Login',
                            showCloseBtn: false,
                            callback: function () {
                                api.call(api.logout(), function () {
                                    mixpanelService.reset();
                                    $window.location.href = '/login';
                                });
                            }
                        });

                        return;
                    }

                    defaultErrorHandler();
                }
            }

        };
    }])

;
